import { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Form } from 'redux-form';

import { handleAddressChange } from 'checkout/checkout/common/helpers';
import { requiresShipping } from 'checkout/checkout/helpers';
import AddressForm from 'common/components/address/AddressForm';
import {
  transformAddressData,
  initialFormValues
} from 'common/components/address/helpers';
import { FormError } from 'common/components/layout';
import {
  getDefaultCountryCode,
  getOperatingCountryCodes,
  getCartTitle
} from 'common/helpers/miscHelper';
import { convertStringToInteger } from 'common/helpers/numberHelper';
import { phoneFormat } from 'common/helpers/phoneHelper';
import { updateCart, updateAndSaveShippingAddress } from 'redux/cart/actions';
import { listCustomerAddresses } from 'redux/customerAddresses/actions';

import AddressPicker from './components/AddressPicker';
import CustomerDisplay from './components/CustomerDisplay';
import GiftMessage from './components/GiftMessage';
import ShippingInstructions from './components/ShippingInstructions';
import { validateForLoggedInCustomerShip } from './validators';

class Customer extends Component {
  componentDidMount() {
    const { props } = this;
    props.listCustomerAddresses();
  }

  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form);
    const address = { ...data };
    delete address.giftMessage;
    delete address.shippingInstructions;
    const cart = {
      shipTo: { ...address },
      orderDeliveryMethod: 'Ship',
      giftMessage: data.giftMessage,
      shippingInstructions: data.shippingInstructions
    };
    cart.shipTo.potentiallyCopyToBillTo = true;
    const successFunction = () => {
      props.onEdit('shipping');
    };
    props.updateAndSaveShippingAddress(cart, address, successFunction);
  };

  handleAddressChange = (e) => {
    const { props } = this;
    const addressId = e.target.value;
    let address;
    if (addressId) {
      address = props.customerAddresses.data[addressId];
    }
    handleAddressChange(addressId, address, props.change, props.settings);
  };

  handlePickup = (e) => {
    e.preventDefault();
    const { onPickup } = this.props;
    onPickup();
  };

  render() {
    const { cart, customer, change, handleSubmit, form, settings } = this.props;
    const { customerAddresses } = this.props;
    let object = cart.shipTo;
    if (!object) {
      object = { countryCode: getDefaultCountryCode(settings) };
    }
    if (getOperatingCountryCodes(settings).length === 1) {
      object.countryCode = getDefaultCountryCode(settings);
    }
    const title = getCartTitle(settings);
    return (
      <Form
        onSubmit={handleSubmit(this.handleSubmit)}
        className="c7-form"
        method="post"
      >
        <FormError formName={form} />
        <CustomerDisplay customer={customer.data} />
        <p>&nbsp;</p>
        <div className="c7-checkout__content__title">
          <h3>Shipping address</h3>
          <a
            className="c7-checkout__content__title__pickup"
            onClick={this.handlePickup}
          >
            I prefer to pick up my order
          </a>
        </div>
        <AddressPicker
          customerAddresses={customerAddresses.data}
          onAddressChange={this.handleAddressChange}
        />
        <AddressForm
          object={object}
          changeFunction={change}
          type="Operating"
          settings={settings}
        />
        <GiftMessage cart={cart} />
        <ShippingInstructions cart={cart} />

        <div className="c7-checkout__content__buttons">
          {renderButton(cart)}
          <a href="/cart">Return to {title.toLowerCase()}</a>
        </div>
      </Form>
    );
  }
}

const renderButton = (cart) => {
  if (requiresShipping(cart)) {
    return (
      <button className="c7-button" type="submit">
        Continue to shipping method
      </button>
    );
  }
  return (
    <button className="c7-button" type="submit">
      Continue to payment method
    </button>
  );
};

const transformData = (values) => {
  const data = transformAddressData(values);
  data.customerAddressId = values.customerAddressId;
  if (values.isGiftMessage) {
    data.giftMessage = values.giftMessage;
  } else {
    data.giftMessage = null;
  }
  if (values.isShippingInstructions) {
    data.shippingInstructions = values.shippingInstructions;
  } else {
    data.shippingInstructions = null;
  }
  return data;
};

const validate = (values, ownProps) => {
  const data = transformData(values);
  data.birthDay = values.birthDay && convertStringToInteger(values.birthDay);
  data.birthMonth =
    values.birthMonth && convertStringToInteger(values.birthMonth);
  data.birthYear = values.birthYear && convertStringToInteger(values.birthYear);
  const errors = validateForLoggedInCustomerShip(data, ownProps.settings);
  return errors;
};

const mapStateToProps = (state, ownProps) => {
  const { shipTo } = ownProps.cart;
  const { customer } = state;

  let initialValues;
  if (shipTo) {
    initialValues = initialFormValues(shipTo);
  } else {
    initialValues = initialFormValues(customer.data);
    if (customer.data.phones.length) {
      initialValues.phone = phoneFormat(
        customer.data.phones[0].phone,
        customer.data.countryCode
      );
    }
  }

  initialValues.giftMessage = ownProps.cart.giftMessage;
  initialValues.isGiftMessage = !!ownProps.cart.giftMessage;

  initialValues.shippingInstructions = ownProps.cart.shippingInstructions;
  initialValues.isShippingInstructions = !!ownProps.cart.shippingInstructions;

  if (
    !initialValues.countryCode ||
    getOperatingCountryCodes(state.setting).length === 1
  ) {
    initialValues.countryCode = getDefaultCountryCode(state.setting);
  }
  return {
    customer: state.customer,
    settings: state.setting,
    customerAddresses: state.customerAddress,
    initialValues
  };
};

Customer = reduxForm({
  form: 'customerLoggedInShip',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(Customer);

export default connect(mapStateToProps, {
  listCustomerAddresses,
  updateAndSaveShippingAddress,
  updateCart
})(Customer);
